<div [class]="`${inputFieldClasses() ?? 'inputField'}`">
  @if (fieldType() === 'Position') {
    <re-lat-long-template
      [required]="required()"
      [labelWidthPercentage]="labelWidthPercentage() || 0"
      (formTouched)="fieldTouched()"
      (formChanged)="positionValueChanged($event)"
    />
  }

  @if (fieldType() !== 'Position') {
    @if (fieldLabel()) {
      <div
        class="labelContainer"
        [style.width]="`${labelWidthPercentage()}%`"
      >
        @if (required()) {
          <span id="required">*</span>
        } @else {
          <span [style]="{ width: '23px' }"></span>
        }
        <div>
          <label [for]="id()">{{ fieldLabel() }}</label>
          @if (fieldDescription()) {
            <div class="m-0 pr-3 text-right text-[0.65rem] text-gray-400">
              {{ fieldDescription() }}
            </div>
          }
        </div>
      </div>
    }
    <div
      class="fieldContainer h-full"
      [style.width]="`${fieldWidthPercentage()}%`"
    >
      @if (fieldType() === 'Text') {
        <div class="container">
          <input
            pInputText
            [name]="id() ?? ''"
            [id]="id()"
            (change)="valueChange()"
            (input)="valueChange()"
            (focus)="fieldTouched()"
            [(ngModel)]="value"
            [disabled]="disabled() || isFieldReadOnly()"
            [required]="required()"
          />
        </div>
      }

      @if (fieldType() === 'Calendar') {
        <div class="inputContainer">
          <p-datepicker
            [name]="id() ?? ''"
            [id]="id()"
            [readonlyInput]="true"
            [inputStyleClass]="
              isError
                ? '!rounded-none !rounded-l-lg border-2 border-solid border-red-500'
                : '!rounded-none !rounded-l-lg'
            "
            [showTime]="true"
            hourFormat="24"
            dateFormat="dd/mm/yy"
            [hideOnDateTimeSelect]="false"
            [(ngModel)]="value"
            (onClearClick)="valueChange()"
            (onClear)="valueChange()"
            (onSelect)="valueChange()"
            (onClose)="valueChange()"
            (onInput)="valueChange()"
            (onFocus)="fieldTouched()"
            (onBlur)="fieldTouched()"
            [disabled]="disabled() || isFieldReadOnly()"
            [minDate]="minDate()"
          />
          <span id="icon">
            <nsp-icon [name]="IconNames.Calendar" />
          </span>
        </div>
      }

      @if (fieldType() === 'Select') {
        <p-select
          #select
          [id]="id()"
          [name]="id() ?? ''"
          [filter]="false"
          [options]="fieldOptions()"
          optionLabel="name"
          placeholder=""
          [(ngModel)]="value"
          [showClear]="showClearButton()"
          (onChange)="valueChange()"
          (onFocus)="fieldTouched()"
          [disabled]="disabled() || isFieldReadOnly()"
          class="h-full min-w-0 items-center"
        />
      }

      @if (fieldType() === 'Number') {
        <div class="inputContainer">
          <p-inputnumber
            [name]="id() ?? ''"
            [inputStyleClass]="getNumberInputStyleClass()"
            [minFractionDigits]="0"
            [maxFractionDigits]="3"
            [min]="minValue()"
            [id]="id()"
            (onInput)="valueChange()"
            (onFocus)="fieldTouched()"
            [(ngModel)]="value"
            [useGrouping]="useNumberGrouping()"
            [disabled]="disabled() || isFieldReadOnly()"
          />
          @if (fieldUnit()) {
            <span
              class="rounded-r-lg"
              id="icon"
            >
              {{ fieldUnit() }}
            </span>
          }
        </div>
      }

      @if (fieldType() === 'Checkbox') {
        <div class="container">
          <p-checkbox
            [id]="id()"
            [binary]="true"
            (onChange)="valueChange()"
            (onFocus)="fieldTouched()"
            [(ngModel)]="value"
            [disabled]="disabled() || isFieldReadOnly()"
          />
        </div>
      }
    </div>
  }
</div>
